"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Burns = void 0;
const client_1 = require("@arkecosystem/client");
class Burns extends client_1.Resource {
    async all(query) {
        return this.sendGet("nft/burns", query);
    }
    async get(id) {
        return this.sendGet(`nft/burns/${id}`);
    }
}
exports.Burns = Burns;
//# sourceMappingURL=burns.js.map